export default {
  title: {
    id: 'seller_options_integrations_info_block_title',
    defaultMessage: 'API & Integrations',
  },
  documentation: {
    id: 'seller_options_integrations_info_block_api_documentation',
    defaultMessage: 'API Documentation',
  },
  create: {
    id: 'seller_options_integrations_info_block_add_new_integration',
    defaultMessage: 'Add new integration',
  },
  text: {
    id: 'seller_options_integrations_info_block_text',
    defaultMessage:
      'Add a new integration to obtain your token and communicate through our API(s) Webservices. Our Webservices allows you to automatically symchronize your ERP with ours, in order to synchronize your stock, prices or automatically receive orders.',
  },
}
